import { render, staticRenderFns } from "./receivingAddress.vue?vue&type=template&id=23c32b38"
import script from "./receivingAddress.vue?vue&type=script&lang=js"
export * from "./receivingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports